import React, { useMemo, useState } from 'react'
import { useOperationsRequests } from '@api/useOperationsRequests'
import moment from 'moment'
import { Dropdown, Menu, Popconfirm } from 'antd'
import { EllipsisOutlined } from '@ant-design/icons'

export const ActionColumnCellRenderer = (status, params) => {
  const [visible, setVisible] = useState(false)
  const { deleteRequestMutation, editRequestMutation } = useOperationsRequests()
  const editRequest = async (payload) => {
    try {
      await editRequestMutation.mutateAsync(payload)
      return true
    } catch (e) {
      console.error('Could not edit request', { e })
    }
  }
  const deleteRequest = async () => {
    await deleteRequestMutation.mutateAsync(params.data._id)
    setVisible(false)
  }
  const handleMenuClick = async (item) => {
    const { key } = item
    switch (key) {
      case 'DELETE':
        setVisible(true)
        break
      case 'DUPLICATE':
        const duplicatePayload = {
          from_date: moment(params.data.from_date).toISOString(),
          to_date: moment(params.data.to_date).toISOString(),
          status: 'open',
          note: params.data.note,
          subject: params.data.subject,
          type: params.data.type,
        }
        return editRequest(duplicatePayload)
      case 'COMPLETE':
        const completePayload = {
          ...params.data,
          status: 'complete',
        }
        return editRequest(completePayload)
      case 'REOPEN':
        const reopenPayload = {
          ...params.data,
          status: 'open',
        }
        return editRequest(reopenPayload)
      default:
        return null
    }
  }
  const menuItems = useMemo(() => {
    if (params?.data?.status === 'complete') {
      return [{ label: 'Reopen', key: 'REOPEN' }]
    }
    if (params?.data?.status === 'open' && params?.data?.owner) {
      return [
        { label: 'Complete', key: 'COMPLETE' },
        { label: 'Delete', key: 'DELETE' },
      ]
    }
    if (params?.data?.status === 'open' && !params?.data?.owner) {
      return [{ label: 'Delete', key: 'DELETE' }]
    }
    return []
  }, [status])

  const items = [
    {
      type: 'group',
      children: [
        {
          label: 'Duplicate',
          key: 'DUPLICATE',
        },
        ...menuItems,
      ],
    },
  ]

  const menu = <Menu onClick={handleMenuClick} items={items} />
  return (
    <Popconfirm
      title={'Are you sure you want to delete this request?'}
      visible={visible}
      okText={'Confirm'}
      onCancel={() => setVisible(false)}
      onConfirm={deleteRequest}
    >
      <Dropdown overlay={menu}>
        <EllipsisOutlined className={'text-size-6'} />
      </Dropdown>
    </Popconfirm>
  )
}
